import { render, staticRenderFns } from "./DatosCompradoresComponent.vue?vue&type=template&id=cd9a9198&scoped=true"
import script from "./DatosCompradoresComponent.vue?vue&type=script&lang=js"
export * from "./DatosCompradoresComponent.vue?vue&type=script&lang=js"
import style0 from "./DatosCompradoresComponent.vue?vue&type=style&index=0&id=cd9a9198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9a9198",
  null
  
)

export default component.exports